module.exports = __webpack_public_path__ + "img/hr-V-R-246-unload-standup-top.8b196748.png";